import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './DebugContainer.css'

class DebugContainer extends Component {
    static defaultProps = {};

    static propTypes = {};
    render() {
        return (
            <div id="debugContainer">{this.props.message}</div>
        );
    }
}

export default DebugContainer;



// WEBPACK FOOTER //
// ./src/components/DebugContainer/DebugContainer.js